import { render, staticRenderFns } from "./NmcReport.vue?vue&type=template&id=510b2502"
import script from "./NmcReport.vue?vue&type=script&lang=js"
export * from "./NmcReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports